import { TEntity, TEntityRef } from '@ws/shared/types';

export function getEntityRef(entity: TEntity): TEntityRef {
  return { id: entity.id, type: entity.type };
}
